import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';

/** Sessão expirou no meio do uso: volta para o login. */
export const unauthorizedInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const auth = inject(AuthService);
  return next(req).pipe(
    catchError((err: unknown) => {
      const skip = req.url.endsWith('/api/admin/me') || req.url.endsWith('/api/admin/login');
      if (err instanceof HttpErrorResponse && (err.status === 401 || err.status === 419) && !skip) {
        auth.user.set(null);
        router.navigateByUrl('/login');
      }
      return throwError(() => err);
    }),
  );
};
